import React from 'react'
import { Drawer, Form, Select, Button, notification, Alert } from 'antd'
import { getMarketingUserByUniversityFxn } from '../users/actions/user'
import { updateMarketingUserForAllAgentsFxn, updateMarketingUserForZeroCaseAgentsFxn } from './actions'
import { listAllCountries } from '../countries/actions/countries'
import { filterOption } from '../../components/_utils/appUtils'

const FormItem = Form.Item
const { Option } = Select

class UpdateAllMarketingUserZeroCaseDrawer extends React.Component {
  state = {
    selectedUser: null,
    allCountries: [],
    countryId: ''
  }

  componentDidMount() {
    this.loadCountry()
  }

  handleUserChange = (userId) => {
    const user = this.state.marketingUserList.find((u) => u._id === userId)

    this.setState({ selectedUser: user }, () => {
      if (user) {
        this.props.form.setFieldsValue({
          name: user.name,
          email: user.email
        })
      }
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()
    const { form, dispatch, filters, showZeroCase } = this.props
    const { countryId } = this.state
    form.validateFields(async (err, values) => {
      if (!err) {
        if (!countryId) {
          notification.error({ message: 'Country not found' })
          return
        }
        if (!values.marketingUserId) {
          notification.error({ message: 'Please choose marketing user' })
          return
        }
        values.countryId = countryId
        delete filters.results
        delete filters.count

        let finalFilters = {
          filters: { ...filters, showZeroCase },
          data: values
        }
        let resp = await dispatch(updateMarketingUserForZeroCaseAgentsFxn(finalFilters))
        if (resp && resp.success) {
          this.props.onClose()
        }
      }
    })
  }

  loadMarketingUser = async () => {
    let obj = {
      countryId: this.state.countryId,
      university: 'Public'
    }
    let { data } = await getMarketingUserByUniversityFxn(obj)
    this.setState({ marketingUserList: data })
  }


  loadCountry = async () => {
    let filters = {
      results: 100,
      count: 100,
      _id: { $in: this.props.marketingCounries }
    }

    let { data } = await this.props.dispatch(listAllCountries(filters))

    this.setState({
      allCountries: data
    })
  }


  render() {
    const { visible, onClose, form } = this.props
    const { getFieldDecorator } = form

    return (
      <Drawer
        visible={visible}
        width='30%'
        placement='right'
        onClose={onClose}
        title='Update Marketing User In All Agents'>
        <div className={'unizportal'}>
          <div className={'card'}>
            <Form onSubmit={this.handleSubmit} layout='vertical'>
              {/* Select Country */}
              <FormItem label='Select Country'>
                {getFieldDecorator('countryId', {
                  rules: [{ required: true, message: 'Please select a country' }]
                })(
                  <Select
                    name='Country'
                    onChange={(x) => {
                      this.setState({ countryId: x }, () => {
                        this.loadMarketingUser()
                      })
                    }}
                    filterOption={filterOption}
                    allowClear
                    showSearch
                    placeholder='Select Country'
                    value={this.state.countryId || undefined}
                    style={{ minWidth: 200 }}
                  >
                    {this.state.allCountries.map((item) => (
                      <Option value={item._id} key={item._id}>
                        {item.countryName}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>

              {/* Select User */}
              <FormItem label='Select User'>
                {getFieldDecorator('marketingUserId', {
                  rules: [{ required: true, message: 'Please select a user' }]
                })(
                  <Select
                    placeholder='Select a user'
                    onChange={(e) => {
                      this.setState({ marketingUserId: e })
                    }}
                    showSearch
                  >
                    {this.state.marketingUserList &&
                    this.state.marketingUserList.length > 0 &&
                    this.state.marketingUserList.map((user) => (
                      <Option key={user._id} value={user._id}>
                        {user.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </FormItem>

              {/* Submit Button */}
              <FormItem>
                <Button type='primary' htmlType='submit'>
                  Update All Agents
                </Button>
              </FormItem>
            </Form>

          </div>
        </div>
      </Drawer>
    )
  }
}

export default Form.create()(UpdateAllMarketingUserZeroCaseDrawer)
